import request from '@/common/request';
// OSS 签名
export function GetSign() {
    return request({
      url: '/store/oss/getSign',
      method: 'GET',
    });
  }